export const PASSWORD_MINIMUM_AGE_MESSAGE =
  'A password change was already performed within the last 24 hours. Please wait until [0] at [1] Central time to try again.';

export function buildPasswordMinimumAgeMessage(
  template: string,
  retryDate: string,
  retryTime: string
): string {
  return template.replace('[0]', retryDate).replace('[1]', retryTime);
}
